"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiCheckCircle } from "react-icons/pi";

export default function SaasPricing({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const plans = content.plans || [
    { name: "Starter", price: "29", period: "/mo", desc: "For individuals", features: ["1 User", "10 Projects", "Basic Support"], buttonText: "Start Trial", link: "#" },
    { name: "Pro", price: "79", period: "/mo", desc: "For growing teams", features: ["Unlimited Users", "50 Projects", "24/7 Support"], buttonText: "Get Pro", link: "#" }
  ];

  return (
    <section
      className={`py-24 px-6 bg-slate-950 text-white transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
            <EditableText
              value={content.title || "Simple, transparent pricing"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {plans.map((plan: any, idx: number) => (
            <div key={idx} className="bg-slate-900 p-8 rounded-2xl border border-slate-800 space-y-6 flex flex-col justify-between">
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-blue-400">{plan.name}</h3>
                <div className="flex items-baseline">
                  <span className="text-4xl font-extrabold">${plan.price}</span>
                  <span className="text-slate-400 text-sm ml-1">{plan.period}</span>
                </div>
                <p className="text-slate-400 text-sm">{plan.desc}</p>
                <ul className="space-y-2 pt-2">
                  {plan.features?.map((feat: string, fIdx: number) => (
                    <li key={fIdx} className="flex items-center gap-2 text-sm text-slate-300">
                      <PiCheckCircle className="w-4 h-4 text-blue-500 flex-shrink-0" />
                      <span>{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-6">
                <a
                  href={plan.link || "#"}
                  className="block text-center py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm transition-all"
                >
                  {plan.buttonText || "Choose Plan"}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
